import { dynamicAssets, staticImageAssets } from 'js/constants/Paths';
import { parseSrcSetImages } from 'js/utils/general';

export const parseVisionAndValuesData = (data) => {
  const { header = {} } = data;
  const { image: headerImage = '' } = header;

  headerImage !== '' && (header.image = dynamicAssets(header.image));

  return { ...data };
};
